import axios from 'axios';
import { BarsLoadingIndicator } from 'components/common/barsLoadingIndicator';
import { Checkbox } from 'components/common/checkbox';
import { Dropdown } from 'components/common/dropdown';
import { Input } from 'components/common/input';
import { FinalStepBookingForm } from 'components/finalStepBookingForm';
import { useGetBookingData } from 'hooks';
import { isArray, isEmpty } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    FaCreditCard,
    FaEnvelope,
    FaLock,
    FaRegBuilding,
} from 'react-icons/fa';
import {
    setCartMobileOpen,
    setCartPayDirectly,
    setCurrentStep,
    setFinalPrices,
    setIsCompleteCart,
} from 'features/cart/cartSlice';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import './CartContactForm.css';
import { apiConfig } from 'config';
import { setCartID } from 'features/MiniBookingWidget/MiniBookingWidgetSlice';
import { PleaseWaitForm } from 'components/pleaseWaitForm';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
function CartContactForm({ extraClass }) {
    const dispatch = useDispatch();
    const { userBookingData } = useGetBookingData();

    const colors = useSelector(
        (state) => state.miniBookingWidget?.data?.colors
    );
    const ipCountry = useSelector(
        (state) => state.miniBookingWidget?.data?.ipCountry
    );
    const pluginCountries = useSelector(
        (state) => state.miniBookingWidget?.data?.pluginCountries
    );

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const paymentMethods = useSelector(
        (state) => state.miniBookingWidget?.data?.paymentMethods
    );

    const cartData = useSelector((state) => state.cart);
    const cartItems = cartData?.cartItems;
    const payDirectly = cartData?.payDirectly;

    const [currentLocalStep, setCurrentLocalStep] = useState(1);
    const cardMethods = paymentMethods.filter((meth) => meth.PaymentType === 1);
    const bankMethods = paymentMethods.filter((meth) => meth.PaymentType === 2);

    const div1Ref = useRef();
    const div2Ref = useRef();
    const div3Ref = useRef();

    const [firstName, setFirstName] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [nationality, setNationality] = useState(
        pluginCountries[0]?.countryName
    );

    useEffect(() => {
        dispatch(setCartMobileOpen(false));
        if (ipCountry && ipCountry !== '') {
            const matchingCountry = pluginCountries.find(
                (country) => country.countryName === ipCountry
            );
            if (matchingCountry) {
                setNationality(matchingCountry.countryName);
            }
        }
    }, []);
    const [specialRequests, setSpecialRequests] = useState('');
    const [checked, setChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [postalCode, setPostalCode] = useState('');
    const [bookingID, setBookingID] = useState(null);
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    // const [stateRegion, setStateRegion] = useState('');
    const defaultPaymentOption = bankMethods?.length > 0 ? 'bank' : 'card';
    const [selectedOption, setSelectedOption] = useState(defaultPaymentOption);
    const [submitError, setSubmitError] = useState(false);
    const [card, setCard] = useState({
        cardno: '',
        cardtype: '',
        expirydt: '',
        cvv: '',
        cardname: '',
    });

    const [selectedBankOption, setSelectedBankOption] = useState(0);
    const [selectedCardOption, setSelectedCardOption] = useState(0);

    useEffect(() => {
        if (cardMethods.length === 1) {
            setSelectedCardOption(cardMethods[0].PaymentGatewayID);
        }
    }, [cardMethods]);

    const handleScroll = (ref) => {
        ref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
        });
    };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validateInputs = () => {
        const errors = {};
        let scrolled = false;
        if (!firstName) {
            errors.firstName = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!lastname) {
            errors.lastname = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!email || !emailRegex.test(email)) {
            errors.email = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!phone) {
            errors.phone = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!address) {
            errors.address = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!city) {
            errors.city = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!postalCode) {
            errors.postalCode = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!checked) {
            errors.checked = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div3Ref);
            }
        }

        if (
            (cardMethods?.length > 0 || bankMethods?.length > 0) &&
            payDirectly?.toLowerCase() !== 'token'
        ) {
            if (selectedOption === 'card') {
                if (!selectedCardOption) {
                    errors.paymentMethodsCard = Lang?.requiredField;
                }
            } else if (selectedOption === 'bank') {
                if (!selectedBankOption) {
                    errors.paymentMethodsBank = Lang?.requiredField;
                }
            }
        }

        if (payDirectly?.toLowerCase() === 'token') {
            if (!card?.cardno) {
                errors.cardno = Lang?.requiredField;
                if (!scrolled) {
                    scrolled = !scrolled;
                    handleScroll(div2Ref);
                }
            }

            if (!card?.expirydt) {
                errors.expirydt = Lang?.requiredField;
                if (!scrolled) {
                    scrolled = !scrolled;
                    handleScroll(div2Ref);
                }
            }

            if (!card?.cvv) {
                errors.cvv = Lang?.requiredField;
                if (!scrolled) {
                    scrolled = !scrolled;
                    handleScroll(div2Ref);
                }
            }

            if (!card?.cardname) {
                errors.cardname = Lang?.requiredField;
                if (!scrolled) {
                    scrolled = !scrolled;
                    handleScroll(div2Ref);
                }
            }
        }

        return errors;
    };

    const dropdownOptions = isArray(pluginCountries)
        ? pluginCountries.map((item) => {
              let countryName = item?.countryName;
              if (item?.countryName === 'EN') {
                  countryName = 'US';
              }
              return {
                  dropdownText: item?.countryLocalFullName,
                  dropdownImg: item?.countryImg,
                  dropdownSelected:
                      countryName === nationality || item?.dropdownSelected,
                  dropdownExtraData: {
                      countryCode: countryName,
                  },
                  dropdownValue: countryName,
              };
          })
        : [];

    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            // Component will unmount, update the ref
            isMountedRef.current = false;
        };
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const errors = validateInputs();
        setErrors(errors);

        if (!isEmpty(errors)) {
            return;
        }
        if (selectedOption === 'bank') {
            setCurrentLocalStep(2);
        }
        let tmpNationality = nationality;
        if (nationality === 'EN') {
            tmpNationality = 'US';
        }
        try {
            setIsLoading(true);
            if (payDirectly?.toLowerCase() === 'token') {
                const validationResponse = await cValidation();
                if (validationResponse !== 'ok') {
                    errors.cardno = Lang?.requiredField;
                    errors.expirydt = Lang?.requiredField;
                    errors.cvv = Lang?.requiredField;
                    errors.cardname = Lang?.requiredField;
                    setErrors(errors);
                    toast.error(Lang?.pleaseCheckYourCardDetails, {
                        autoClose: true,
                        theme: 'colored',
                    });
                    setIsLoading(false);
                    return;
                }
            }

            if (selectedOption === 'card') {
                setCurrentLocalStep(2);
                dispatch(setCurrentStep({ currentStep: 3 }));
            }
            const response = await axios.post(apiConfig?.submitCartBack, {
                lang: userBookingData?.localeLanguage,
                firstName,
                lastname,
                email,
                phone,
                nationality: tmpNationality,
                specialRequests,

                address,
                city,
                // stateRegion,
                postalCode,
                cartItems,

                selectedOption,
                selectedBankOption,
                selectedCardOption,
                payDirectly,
                hotelCode: cartItems[0]?.hotelCode,
            });

            if (response?.data.split(',')[0].toLowerCase() === 'ok') {
                if (isMountedRef.current) {
                    toast.success(Lang?.successMessage, {
                        autoClose: true,
                        theme: 'colored',
                    });

                    setBookingID(response?.data.split(',')[1]);
                    if (
                        selectedOption === 'bank' ||
                        payDirectly?.toLowerCase() === 'token'
                    ) {
                        setCurrentLocalStep(2);
                        dispatch(setCurrentStep({ currentStep: 3 }));
                    }

                    dispatch(setIsCompleteCart());
                    const newCartID = response?.data.split(',')[2];
                    dispatch(setCartID(newCartID));
                    if (selectedOption === 'card') {
                        const url = response?.data.split(',')[3];
                        window.location.href = url;
                    }
                }
            } else {
                setCurrentLocalStep(1);
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
            }
        } catch (error) {
            setSubmitError(true);
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
        }

        setIsLoading(false);
    };

    const onChange = (e) => {
        const cartypeNew = cardnumber(e.target.value);
        setCard({
            ...card,
            cardno: e.target.value,
            cardtype: cartypeNew,
        });
    };
    const cardnumber = (inputtxt) => {
        const matches = inputtxt.match(/(\d+)/);
        let cardno = '';
        if (matches) {
            cardno = inputtxt.split(' - ').join('');
        }
        let cardtype1 = card.cardtype;

        const visa = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
        const mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
        const amexpRegEx = /^(?:3[47][0-9]{13})$/;
        const discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
        if (visa.test(cardno) === true) {
            // eg:4651970022334445
            cardtype1 = 'Visa';
        } else if (mastercardRegEx.test(cardno) === true) {
            cardtype1 = 'MasterCard';
        } else if (amexpRegEx.test(cardno) === true) {
            cardtype1 = 'AmericanExpress';
        } else if (discovRegEx.test(cardno) === true) {
            cardtype1 = 'Discover';
        }
        return cardtype1;
    };

    const ccFormat = (value) => {
        const v = value.replace(/[^0-9]/gi, '').substr(0, 16);

        const parts = [];
        for (let i = 0; i < v.length; i += 4) {
            parts.push(v.substr(i, 4));
        }
        return parts.length > 1 ? parts.join(' - ') : value;
    };
    const expriyFormat = (value) => {
        const formattedValue = value.replace(/\D/g, ''); // Remove non-numeric characters
        const MM = formattedValue.substring(0, 2);
        const YY = formattedValue.substring(2, 4);

        let expDateFormatter = '';

        if (MM) {
            expDateFormatter += MM;
            if (YY) {
                expDateFormatter += `/${YY}`;
            }
        }

        return expDateFormatter;
    };

    const onChangeExp = (e) => {
        const formattedValue = e.target.value;
        setCard({ ...card, expirydt: expriyFormat(formattedValue) });
    };
    const onChangeCVV = (e) => {
        setCard({
            ...card,
            cvv: e.target.value,
        });
    };
    const onChangeCardName = (e) => {
        setCard({
            ...card,
            cardname: e.target.value,
        });
    };

    useEffect(() => {
        const getFinalPrices = async () => {
            try {
                const response = await axios.post(apiConfig?.getFinalPrices, {
                    cartID: cartItems[0]?.cartID,
                    propCode: cartItems[0]?.hotelCode,
                });
                const finalPrices = response?.data;
                if (finalPrices?.status?.toLowerCase() === 'ok') {
                    if (finalPrices?.payDirectly?.toLowerCase() === 'token') {
                        dispatch(setCartPayDirectly(finalPrices?.payDirectly));
                    } else {
                        setSelectedOption('card');
                    }
                    dispatch(setFinalPrices(finalPrices?.finalPrices));
                }
            } catch (error) {
                toast.error(Lang?.networkError, {
                    autoClose: true,
                    theme: 'colored',
                });
            }
        };

        getFinalPrices();
    }, []);

    let redBorderClass = '';
    if (errors?.nationality) {
        redBorderClass = 'ab-reb-border';
    }

    const cValidation = async () => {
        // return 'error';
        try {
            const response = await axios.post(apiConfig?.getCValidation, {
                cartID: cartItems[0]?.cartID,
                propCode: cartItems[0]?.hotelCode,
                cNo: card?.cardno,
                cName: card?.cardname,
                cExp: card?.expirydt,
                cCV: card?.cvv,
            });
            return response?.data;
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option);
    };

    const handleBankOptionClick = (option) => {
        setSelectedBankOption(option);
    };

    const handleCardOptionClick = (option) => {
        setSelectedCardOption(option);
    };

    return (
        <div
            className={`ab-cart-info-page ${extraClass}`}
            style={{ marginTop: '20px' }}
        >
            <div className="ab-column">
                <div className="ab-body-innerMain">
                    {currentLocalStep === 1 ? (
                        <form
                            onSubmit={handleSubmit}
                            noValidate
                            style={{ display: 'flex', width: '100%' }}
                        >
                            <div className="ab-book-form-right-wrapper">
                                <div className="ab-body-main ab-cart-form-overf">
                                    <div
                                        className="ab-cart-whitebox ab-p-10"
                                        style={{ minHeight: '280px' }}
                                    >
                                        <div className="ab-cart-whitebox-big-title ab-bf-black">
                                            {Lang?.contactAndPayment}
                                        </div>

                                        <div
                                            ref={div1Ref}
                                            className="ab-booking-form"
                                        >
                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.firstName}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setFirstName(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.firstName
                                                        )}
                                                        errorMsg={
                                                            errors.firstName
                                                        }
                                                        isRequiredBorder={true}
                                                        id="form-FirstName"
                                                    />
                                                </div>
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.lastName}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setLastname(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.lastname
                                                        )}
                                                        errorMsg={
                                                            errors.lastname
                                                        }
                                                        isRequiredBorder={true}
                                                        id="form-LastName"
                                                    />
                                                </div>
                                            </div>

                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.email}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setEmail(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.email
                                                        )}
                                                        errorMsg={errors.email}
                                                        isRequiredBorder={true}
                                                        id="form-Email"
                                                    />
                                                </div>
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.phone}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    {/* <Input
                                                        onChange={(e) =>
                                                            setPhone(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.phone
                                                        )}
                                                        errorMsg={errors.phone}
                                                        isRequiredBorder={true}
                                                        id="form-Phone"
                                                    /> */}
                                                    <div
                                                        className={`ab-input ${
                                                            errors?.phone
                                                                ? 'ab-red-border'
                                                                : ''
                                                        }`}
                                                    >
                                                        <PhoneInput
                                                            country={
                                                                ipCountry.toLowerCase() ||
                                                                nationality.toLowerCase()
                                                            }
                                                            value={phone}
                                                            onChange={setPhone}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.city}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setCity(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.city
                                                        )}
                                                        errorMsg={errors.city}
                                                        isRequiredBorder={true}
                                                        id="form-City"
                                                    />
                                                </div>
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.nationality}
                                                    </label>

                                                    <div className="ab-input ab-input-cnt">
                                                        <Dropdown
                                                            onChange={(
                                                                option
                                                            ) => {
                                                                setNationality(
                                                                    option
                                                                        ?.dropdownExtraData
                                                                        ?.countryCode
                                                                );
                                                            }}
                                                            value={nationality}
                                                            searchable
                                                            options={
                                                                dropdownOptions ||
                                                                []
                                                            }
                                                            showTextWhenSelected={
                                                                true
                                                            }
                                                            extraClass={`ab-nationality-dropdown ${redBorderClass}`}
                                                            id="form-Nationality"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.address}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setAddress(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.address
                                                        )}
                                                        errorMsg={
                                                            errors.address
                                                        }
                                                        isRequiredBorder={true}
                                                        id="form-Address"
                                                    />
                                                </div>
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.postalCode}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setPostalCode(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.postalCode
                                                        )}
                                                        errorMsg={
                                                            errors.postalCode
                                                        }
                                                        isRequiredBorder={true}
                                                        id="form-PostalCode"
                                                    />
                                                </div>
                                            </div>

                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.specialRequests}
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setSpecialRequests(
                                                                e.target.value
                                                            )
                                                        }
                                                        type="textarea"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className=""
                                            style={{
                                                marginBottom: '2px',
                                            }}
                                        >
                                            <div className="ab-cart-pay-title">
                                                {Lang?.payWith}
                                            </div>
                                            {payDirectly?.toLowerCase() ===
                                            'token' ? (
                                                <div
                                                    ref={div2Ref}
                                                    className="ab-booking-form ab-mb-20 ab-card-token"
                                                >
                                                    <div className="ab-whitebox-header">
                                                        <div className="first-part">
                                                            <FaLock />{' '}
                                                            {Lang.securePayment}
                                                        </div>
                                                        <div className="second-part">
                                                            {
                                                                Lang.allCardDetailsAreEncrypted
                                                            }
                                                            .
                                                        </div>
                                                    </div>
                                                    <div className="ab-input-field-cnt ab-mb-10">
                                                        <div className=" ab-input-cnt">
                                                            <label className="ab-input-label">
                                                                {
                                                                    Lang.paymentCardNumber
                                                                }
                                                                <span
                                                                    className="ab-input-required-indicator"
                                                                    role="presentation"
                                                                    aria-hidden="true"
                                                                >
                                                                    *
                                                                </span>
                                                            </label>
                                                            <Input
                                                                className="ab-input"
                                                                isRequired
                                                                isInvalid={Boolean(
                                                                    errors?.cardno
                                                                )}
                                                                value={ccFormat(
                                                                    card.cardno
                                                                )}
                                                                errorMsg={
                                                                    errors?.cardno
                                                                }
                                                                isRequiredBorder={
                                                                    true
                                                                }
                                                                onChange={
                                                                    onChange
                                                                }
                                                                onKeyPress={(
                                                                    event
                                                                ) => {
                                                                    if (
                                                                        !/[0-9]/.test(
                                                                            event.key
                                                                        )
                                                                    ) {
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                                id="form-Cardno"
                                                            />
                                                        </div>
                                                        <div className="ab-input-field-cnt ab-same-row">
                                                            <div className=" ab-input-cnt">
                                                                <label className="ab-input-label">
                                                                    {
                                                                        Lang.expiration
                                                                    }{' '}
                                                                    (MM/YY)
                                                                    <span
                                                                        className="ab-input-required-indicator"
                                                                        role="presentation"
                                                                        aria-hidden="true"
                                                                    >
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <Input
                                                                    onChange={
                                                                        onChangeExp
                                                                    }
                                                                    className="ab-input"
                                                                    isRequired
                                                                    isInvalid={Boolean(
                                                                        errors?.expirydt
                                                                    )}
                                                                    errorMsg={
                                                                        errors?.expirydt
                                                                    }
                                                                    isRequiredBorder={
                                                                        true
                                                                    }
                                                                    placeholder="MM/YY"
                                                                    maxlength="5"
                                                                    value={expriyFormat(
                                                                        card.expirydt
                                                                    )}
                                                                    id="form-Expire"
                                                                />
                                                            </div>
                                                            <div className=" ab-input-cnt">
                                                                <label className="ab-input-label">
                                                                    CVV
                                                                    <span
                                                                        className="ab-input-required-indicator"
                                                                        role="presentation"
                                                                        aria-hidden="true"
                                                                    >
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <Input
                                                                    onChange={
                                                                        onChangeCVV
                                                                    }
                                                                    maxlength="3"
                                                                    pattern="[0-9][0-9][0-9]"
                                                                    onKeyPress={(
                                                                        event
                                                                    ) => {
                                                                        if (
                                                                            !/[0-9]/.test(
                                                                                event.key
                                                                            )
                                                                        ) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                    className="ab-input"
                                                                    isRequired
                                                                    isInvalid={Boolean(
                                                                        errors?.cvv
                                                                    )}
                                                                    errorMsg={
                                                                        errors?.cvv
                                                                    }
                                                                    isRequiredBorder={
                                                                        true
                                                                    }
                                                                    id="form-Cvv"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="ab-input-field-cnt ab-mb-10">
                                                        <div className=" ab-input-cnt">
                                                            <label className="ab-input-label">
                                                                {
                                                                    Lang.nameOnCard
                                                                }
                                                                <span
                                                                    className="ab-input-required-indicator"
                                                                    role="presentation"
                                                                    aria-hidden="true"
                                                                >
                                                                    *
                                                                </span>
                                                            </label>
                                                            <Input
                                                                onChange={
                                                                    onChangeCardName
                                                                }
                                                                className="ab-input"
                                                                isRequired
                                                                isInvalid={Boolean(
                                                                    errors?.cardname
                                                                )}
                                                                errorMsg={
                                                                    errors?.cardname
                                                                }
                                                                isRequiredBorder={
                                                                    true
                                                                }
                                                                id="form-CardName"
                                                            />
                                                        </div>
                                                        <div className="ab-input-cnt"></div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="ab-cart-pay-options">
                                                        <div className="ab-payment-options">
                                                            {cardMethods?.length >
                                                                0 && (
                                                                <div
                                                                    className={`ab-cart-radio-option ${
                                                                        selectedOption ===
                                                                        'card'
                                                                            ? 'selected'
                                                                            : ''
                                                                    }`}
                                                                    onClick={() =>
                                                                        handleOptionClick(
                                                                            'card'
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        Lang?.creditCard
                                                                    }
                                                                </div>
                                                            )}
                                                            {bankMethods?.length >
                                                                0 && (
                                                                <div
                                                                    className={`ab-cart-radio-option ${
                                                                        selectedOption ===
                                                                        'bank'
                                                                            ? 'selected'
                                                                            : ''
                                                                    }`}
                                                                    onClick={() =>
                                                                        handleOptionClick(
                                                                            'bank'
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        Lang?.bankTransfer
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="ab-payment-error">
                                                            {errors?.paymentMethodsCard &&
                                                                Lang?.selectACardOption}
                                                            {errors?.paymentMethodsBank &&
                                                                Lang?.selectABankOption}
                                                        </div>
                                                    </div>

                                                    {selectedOption ===
                                                    'card' ? (
                                                        cardMethods?.length >=
                                                        1 ? (
                                                            <div>
                                                                <div className="ab-whitebox-header">
                                                                    <div className="first-part">
                                                                        <FaLock />{' '}
                                                                        {
                                                                            Lang.securePayment
                                                                        }
                                                                    </div>
                                                                    <div className="second-part">
                                                                        {
                                                                            Lang.allCardDetailsAreEncrypted
                                                                        }
                                                                        .
                                                                    </div>
                                                                </div>
                                                                {cardMethods?.map(
                                                                    (
                                                                        pMethod,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <div
                                                                                key={
                                                                                    index
                                                                                }
                                                                                onClick={() =>
                                                                                    handleCardOptionClick(
                                                                                        pMethod.PaymentGatewayID
                                                                                    )
                                                                                }
                                                                                className={`ab-whitebox-body ab-p-10 ab-cart-card-wrapper ${
                                                                                    selectedCardOption ===
                                                                                    pMethod.PaymentGatewayID
                                                                                        ? 'selected'
                                                                                        : ''
                                                                                }`}
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                            >
                                                                                <div className="ab-cart-credit-wrapper">
                                                                                    <div className="ab-cart-credit-icon">
                                                                                        <FaCreditCard />
                                                                                    </div>
                                                                                    <div className="ab-cart-credit-middle">
                                                                                        <div className="ab-cart-credit-title">
                                                                                            {
                                                                                                pMethod.PaymentName
                                                                                            }
                                                                                        </div>
                                                                                        <div className="ab-cart-credit-details">
                                                                                            {
                                                                                                pMethod.PaymentDescription
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="ab-cards-wrapper">
                                                                                    <img
                                                                                        src={`${pMethod.PaymentImg}`}
                                                                                        width="100px"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )
                                                    ) : (
                                                        <div className="ab-whitebox-body ab-p-10">
                                                            {bankMethods?.map(
                                                                (
                                                                    pMethod,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <div
                                                                            key={
                                                                                index
                                                                            }
                                                                            onClick={() =>
                                                                                handleBankOptionClick(
                                                                                    pMethod.PaymentGatewayID
                                                                                )
                                                                            }
                                                                            className={`ab-cart-bank-wrapper ${
                                                                                selectedBankOption ===
                                                                                pMethod.PaymentGatewayID
                                                                                    ? 'selected'
                                                                                    : ''
                                                                            }`}
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        >
                                                                            <div className="ab-cart-bank-left">
                                                                                <FaRegBuilding />
                                                                            </div>
                                                                            <div className="ab-cart-bank-right">
                                                                                <div className="ab-cart-bank-title">
                                                                                    {
                                                                                        pMethod.PaymentName
                                                                                    }
                                                                                </div>
                                                                                <div
                                                                                    className="ab-cart-bank-details"
                                                                                    style={{
                                                                                        flexDirection:
                                                                                            'revert',
                                                                                    }}
                                                                                >
                                                                                    <span
                                                                                        style={{
                                                                                            marginRight:
                                                                                                '5px',
                                                                                        }}
                                                                                    >
                                                                                        IBAN
                                                                                        -{' '}
                                                                                    </span>
                                                                                    <span>
                                                                                        {
                                                                                            pMethod?.PaymentExtra
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                                <div className="ab-cart-bank-details">
                                                                                    <span>
                                                                                        {
                                                                                            pMethod.PaymentDescription
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            <div>
                                                <hr />

                                                <label
                                                    className="ab-pt-10 ab-pb-10 ab-booking-form-terms"
                                                    style={{
                                                        display: 'flex',
                                                        cursor: 'pointer',
                                                    }}
                                                    id="form-checkbox"
                                                    ref={div3Ref}
                                                >
                                                    <Checkbox
                                                        className="ab-booking-form-checkbox"
                                                        id="termsCheck"
                                                        isChecked={checked}
                                                        onChange={(event) =>
                                                            setChecked(
                                                                event.target
                                                                    .checked
                                                            )
                                                        }
                                                    >
                                                        <span
                                                            style={{
                                                                paddingRight:
                                                                    '3px',
                                                            }}
                                                        >
                                                            {
                                                                Lang?.iHaveReadAndIAcceptThe
                                                            }
                                                        </span>
                                                    </Checkbox>

                                                    {Lang?.TmpTermsAndConditions && (
                                                        <div>
                                                            <a
                                                                className="ab-booking-form-terms-inner"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                href={
                                                                    Lang?.TmpTermsAndConditions
                                                                }
                                                            >
                                                                {
                                                                    Lang?.termsAndPrivacyPolicy
                                                                }
                                                            </a>
                                                        </div>
                                                    )}
                                                </label>
                                                {Boolean(errors?.checked) && (
                                                    <span className="ab-cart-form-check-required">
                                                        {Lang?.requiredField}
                                                    </span>
                                                )}
                                                <hr />
                                                <div
                                                    className="mail-send-info ab-pt-10 ab-pb-10"
                                                    style={{
                                                        paddingLeft: '2px',
                                                    }}
                                                >
                                                    <FaEnvelope size={16} />
                                                    <span className="ab-booking-form-email-text">
                                                        {
                                                            Lang?.wellSendConfirmationOfBookingToEmail
                                                        }{' '}
                                                        <strong>{email}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ab-booking-form-button-wrapper">
                                        <button
                                            type="submit"
                                            className="ab-full-width-big-btn"
                                            style={{
                                                backgroundColor: '#2a4090',
                                                color: colors?.primaryTextColor,
                                            }}
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <BarsLoadingIndicator />
                                            ) : (
                                                Lang?.confirmAndBook
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <>
                            {!submitError && (
                                <>
                                    {selectedOption === 'card' ? (
                                        <PleaseWaitForm
                                            isLoading={isLoading}
                                            text={
                                                Lang?.thankYouForYourPatiencePleaseWait
                                            }
                                        />
                                    ) : isLoading ? (
                                        <PleaseWaitForm
                                            isLoading={isLoading}
                                            text={
                                                Lang?.thankYouForYourPatiencePleaseWaitEmail
                                            }
                                        />
                                    ) : (
                                        <FinalStepBookingForm
                                            bookingID={bookingID}
                                        />
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

CartContactForm.propTypes = {
    extraClass: PropTypes.string,
};

export default CartContactForm;
